/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic } from '../fn/recovering/create-one-base-mgmt-recovering-characteristic-controller-recovering-characteristic';
import { CreateOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params } from '../fn/recovering/create-one-base-mgmt-recovering-characteristic-controller-recovering-characteristic';
import { createOneBaseMgmtRecoveringProductControllerRecoveringProduct } from '../fn/recovering/create-one-base-mgmt-recovering-product-controller-recovering-product';
import { CreateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params } from '../fn/recovering/create-one-base-mgmt-recovering-product-controller-recovering-product';
import { createOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine } from '../fn/recovering/create-one-base-mgmt-recovering-product-line-controller-recovering-product-line';
import { CreateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params } from '../fn/recovering/create-one-base-mgmt-recovering-product-line-controller-recovering-product-line';
import { createOneBaseMgmtRecoveringStockControllerRecoveringStock } from '../fn/recovering/create-one-base-mgmt-recovering-stock-controller-recovering-stock';
import { CreateOneBaseMgmtRecoveringStockControllerRecoveringStock$Params } from '../fn/recovering/create-one-base-mgmt-recovering-stock-controller-recovering-stock';
import { deleteOneBaseMgmtRecoveringProductControllerRecoveringProduct } from '../fn/recovering/delete-one-base-mgmt-recovering-product-controller-recovering-product';
import { DeleteOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params } from '../fn/recovering/delete-one-base-mgmt-recovering-product-controller-recovering-product';
import { deleteOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine } from '../fn/recovering/delete-one-base-mgmt-recovering-product-line-controller-recovering-product-line';
import { DeleteOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params } from '../fn/recovering/delete-one-base-mgmt-recovering-product-line-controller-recovering-product-line';
import { deleteOneBaseMgmtRecoveringStockControllerRecoveringStock } from '../fn/recovering/delete-one-base-mgmt-recovering-stock-controller-recovering-stock';
import { DeleteOneBaseMgmtRecoveringStockControllerRecoveringStock$Params } from '../fn/recovering/delete-one-base-mgmt-recovering-stock-controller-recovering-stock';
import { getManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic } from '../fn/recovering/get-many-base-mgmt-recovering-characteristic-controller-recovering-characteristic';
import { GetManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params } from '../fn/recovering/get-many-base-mgmt-recovering-characteristic-controller-recovering-characteristic';
import { getManyBaseMgmtRecoveringProductControllerRecoveringProduct } from '../fn/recovering/get-many-base-mgmt-recovering-product-controller-recovering-product';
import { GetManyBaseMgmtRecoveringProductControllerRecoveringProduct$Params } from '../fn/recovering/get-many-base-mgmt-recovering-product-controller-recovering-product';
import { getManyBaseMgmtRecoveringProductLineControllerRecoveringProductLine } from '../fn/recovering/get-many-base-mgmt-recovering-product-line-controller-recovering-product-line';
import { GetManyBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params } from '../fn/recovering/get-many-base-mgmt-recovering-product-line-controller-recovering-product-line';
import { getManyBaseMgmtRecoveringStockControllerRecoveringStock } from '../fn/recovering/get-many-base-mgmt-recovering-stock-controller-recovering-stock';
import { GetManyBaseMgmtRecoveringStockControllerRecoveringStock$Params } from '../fn/recovering/get-many-base-mgmt-recovering-stock-controller-recovering-stock';
import { getManyBaseRecoveringProductControllerByLineRecoveringProduct } from '../fn/recovering/get-many-base-recovering-product-controller-by-line-recovering-product';
import { GetManyBaseRecoveringProductControllerByLineRecoveringProduct$Params } from '../fn/recovering/get-many-base-recovering-product-controller-by-line-recovering-product';
import { getManyBaseRecoveringProductLineControllerRecoveringProductLine } from '../fn/recovering/get-many-base-recovering-product-line-controller-recovering-product-line';
import { GetManyBaseRecoveringProductLineControllerRecoveringProductLine$Params } from '../fn/recovering/get-many-base-recovering-product-line-controller-recovering-product-line';
import { GetManyRecoveringCharacteristicResponseDto } from '../models/get-many-recovering-characteristic-response-dto';
import { GetManyRecoveringProductLineResponseDto } from '../models/get-many-recovering-product-line-response-dto';
import { GetManyRecoveringProductResponseDto } from '../models/get-many-recovering-product-response-dto';
import { GetManyRecoveringStockResponseDto } from '../models/get-many-recovering-stock-response-dto';
import { getOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic } from '../fn/recovering/get-one-base-mgmt-recovering-characteristic-controller-recovering-characteristic';
import { GetOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params } from '../fn/recovering/get-one-base-mgmt-recovering-characteristic-controller-recovering-characteristic';
import { getOneBaseMgmtRecoveringProductControllerRecoveringProduct } from '../fn/recovering/get-one-base-mgmt-recovering-product-controller-recovering-product';
import { GetOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params } from '../fn/recovering/get-one-base-mgmt-recovering-product-controller-recovering-product';
import { getOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine } from '../fn/recovering/get-one-base-mgmt-recovering-product-line-controller-recovering-product-line';
import { GetOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params } from '../fn/recovering/get-one-base-mgmt-recovering-product-line-controller-recovering-product-line';
import { getOneBaseMgmtRecoveringStockControllerRecoveringStock } from '../fn/recovering/get-one-base-mgmt-recovering-stock-controller-recovering-stock';
import { GetOneBaseMgmtRecoveringStockControllerRecoveringStock$Params } from '../fn/recovering/get-one-base-mgmt-recovering-stock-controller-recovering-stock';
import { getOneBaseRecoveringProductControllerByLineRecoveringProduct } from '../fn/recovering/get-one-base-recovering-product-controller-by-line-recovering-product';
import { GetOneBaseRecoveringProductControllerByLineRecoveringProduct$Params } from '../fn/recovering/get-one-base-recovering-product-controller-by-line-recovering-product';
import { getOneBaseRecoveringProductControllerRecoveringProduct } from '../fn/recovering/get-one-base-recovering-product-controller-recovering-product';
import { GetOneBaseRecoveringProductControllerRecoveringProduct$Params } from '../fn/recovering/get-one-base-recovering-product-controller-recovering-product';
import { getOneBaseRecoveringProductLineControllerRecoveringProductLine } from '../fn/recovering/get-one-base-recovering-product-line-controller-recovering-product-line';
import { GetOneBaseRecoveringProductLineControllerRecoveringProductLine$Params } from '../fn/recovering/get-one-base-recovering-product-line-controller-recovering-product-line';
import { mgmtRecoveringProductLineControllerSortDown } from '../fn/recovering/mgmt-recovering-product-line-controller-sort-down';
import { MgmtRecoveringProductLineControllerSortDown$Params } from '../fn/recovering/mgmt-recovering-product-line-controller-sort-down';
import { mgmtRecoveringProductLineControllerSortUp } from '../fn/recovering/mgmt-recovering-product-line-controller-sort-up';
import { MgmtRecoveringProductLineControllerSortUp$Params } from '../fn/recovering/mgmt-recovering-product-line-controller-sort-up';
import { mgmtRecoveringStockControllerGetAlerts } from '../fn/recovering/mgmt-recovering-stock-controller-get-alerts';
import { MgmtRecoveringStockControllerGetAlerts$Params } from '../fn/recovering/mgmt-recovering-stock-controller-get-alerts';
import { mgmtRecoveringStockControllerGetQuantityDetails } from '../fn/recovering/mgmt-recovering-stock-controller-get-quantity-details';
import { MgmtRecoveringStockControllerGetQuantityDetails$Params } from '../fn/recovering/mgmt-recovering-stock-controller-get-quantity-details';
import { RecoveringCharacteristic } from '../models/recovering-characteristic';
import { RecoveringProduct } from '../models/recovering-product';
import { RecoveringProductLine } from '../models/recovering-product-line';
import { RecoveringStock } from '../models/recovering-stock';
import { RecoveringStockQuantityDetails } from '../models/recovering-stock-quantity-details';
import { recoverOneBaseMgmtRecoveringProductControllerRecoveringProduct } from '../fn/recovering/recover-one-base-mgmt-recovering-product-controller-recovering-product';
import { RecoverOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params } from '../fn/recovering/recover-one-base-mgmt-recovering-product-controller-recovering-product';
import { recoverOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine } from '../fn/recovering/recover-one-base-mgmt-recovering-product-line-controller-recovering-product-line';
import { RecoverOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params } from '../fn/recovering/recover-one-base-mgmt-recovering-product-line-controller-recovering-product-line';
import { updateOneBaseMgmtRecoveringProductControllerRecoveringProduct } from '../fn/recovering/update-one-base-mgmt-recovering-product-controller-recovering-product';
import { UpdateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params } from '../fn/recovering/update-one-base-mgmt-recovering-product-controller-recovering-product';
import { updateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine } from '../fn/recovering/update-one-base-mgmt-recovering-product-line-controller-recovering-product-line';
import { UpdateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params } from '../fn/recovering/update-one-base-mgmt-recovering-product-line-controller-recovering-product-line';
import { updateOneBaseMgmtRecoveringStockControllerRecoveringStock } from '../fn/recovering/update-one-base-mgmt-recovering-stock-controller-recovering-stock';
import { UpdateOneBaseMgmtRecoveringStockControllerRecoveringStock$Params } from '../fn/recovering/update-one-base-mgmt-recovering-stock-controller-recovering-stock';

@Injectable({ providedIn: 'root' })
export class RecoveringApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getOneBaseRecoveringProductControllerRecoveringProduct()` */
  static readonly GetOneBaseRecoveringProductControllerRecoveringProductPath = '/api/public/recovering-product/{id}';

  /**
   * Retrieve a single RecoveringProduct.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseRecoveringProductControllerRecoveringProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseRecoveringProductControllerRecoveringProduct$Response(params: GetOneBaseRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProduct>> {
    const obs = getOneBaseRecoveringProductControllerRecoveringProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single RecoveringProduct.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseRecoveringProductControllerRecoveringProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseRecoveringProductControllerRecoveringProduct(params: GetOneBaseRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<RecoveringProduct> {
    const resp = this.getOneBaseRecoveringProductControllerRecoveringProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringProduct>): RecoveringProduct => r.body)
    );
  }

  /** Path part for operation `getManyBaseRecoveringProductControllerByLineRecoveringProduct()` */
  static readonly GetManyBaseRecoveringProductControllerByLineRecoveringProductPath = '/api/public/recovering-product-line/{recoveringProductLineId}/recovering-product';

  /**
   * Retrieve multiple RecoveringProducts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseRecoveringProductControllerByLineRecoveringProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseRecoveringProductControllerByLineRecoveringProduct$Response(params: GetManyBaseRecoveringProductControllerByLineRecoveringProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyRecoveringProductResponseDto>> {
    const obs = getManyBaseRecoveringProductControllerByLineRecoveringProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple RecoveringProducts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseRecoveringProductControllerByLineRecoveringProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseRecoveringProductControllerByLineRecoveringProduct(params: GetManyBaseRecoveringProductControllerByLineRecoveringProduct$Params, context?: HttpContext): Observable<GetManyRecoveringProductResponseDto> {
    const resp = this.getManyBaseRecoveringProductControllerByLineRecoveringProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyRecoveringProductResponseDto>): GetManyRecoveringProductResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseRecoveringProductControllerByLineRecoveringProduct()` */
  static readonly GetOneBaseRecoveringProductControllerByLineRecoveringProductPath = '/api/public/recovering-product-line/{recoveringProductLineId}/recovering-product/{id}';

  /**
   * Retrieve a single RecoveringProduct.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseRecoveringProductControllerByLineRecoveringProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseRecoveringProductControllerByLineRecoveringProduct$Response(params: GetOneBaseRecoveringProductControllerByLineRecoveringProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProduct>> {
    const obs = getOneBaseRecoveringProductControllerByLineRecoveringProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single RecoveringProduct.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseRecoveringProductControllerByLineRecoveringProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseRecoveringProductControllerByLineRecoveringProduct(params: GetOneBaseRecoveringProductControllerByLineRecoveringProduct$Params, context?: HttpContext): Observable<RecoveringProduct> {
    const resp = this.getOneBaseRecoveringProductControllerByLineRecoveringProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringProduct>): RecoveringProduct => r.body)
    );
  }

  /** Path part for operation `getOneBaseRecoveringProductLineControllerRecoveringProductLine()` */
  static readonly GetOneBaseRecoveringProductLineControllerRecoveringProductLinePath = '/api/public/recovering-product-line/{id}';

  /**
   * Retrieve a single RecoveringProductLine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseRecoveringProductLineControllerRecoveringProductLine()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseRecoveringProductLineControllerRecoveringProductLine$Response(params: GetOneBaseRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProductLine>> {
    const obs = getOneBaseRecoveringProductLineControllerRecoveringProductLine(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single RecoveringProductLine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseRecoveringProductLineControllerRecoveringProductLine$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseRecoveringProductLineControllerRecoveringProductLine(params: GetOneBaseRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<RecoveringProductLine> {
    const resp = this.getOneBaseRecoveringProductLineControllerRecoveringProductLine$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringProductLine>): RecoveringProductLine => r.body)
    );
  }

  /** Path part for operation `getManyBaseRecoveringProductLineControllerRecoveringProductLine()` */
  static readonly GetManyBaseRecoveringProductLineControllerRecoveringProductLinePath = '/api/public/recovering-product-line';

  /**
   * Retrieve multiple RecoveringProductLines.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseRecoveringProductLineControllerRecoveringProductLine()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseRecoveringProductLineControllerRecoveringProductLine$Response(params?: GetManyBaseRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyRecoveringProductLineResponseDto>> {
    const obs = getManyBaseRecoveringProductLineControllerRecoveringProductLine(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple RecoveringProductLines.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseRecoveringProductLineControllerRecoveringProductLine$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseRecoveringProductLineControllerRecoveringProductLine(params?: GetManyBaseRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<GetManyRecoveringProductLineResponseDto> {
    const resp = this.getManyBaseRecoveringProductLineControllerRecoveringProductLine$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyRecoveringProductLineResponseDto>): GetManyRecoveringProductLineResponseDto => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtRecoveringProductControllerRecoveringProduct()` */
  static readonly GetManyBaseMgmtRecoveringProductControllerRecoveringProductPath = '/api/mgmt/recovering-product';

  /**
   * Retrieve multiple RecoveringProducts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtRecoveringProductControllerRecoveringProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtRecoveringProductControllerRecoveringProduct$Response(params?: GetManyBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyRecoveringProductResponseDto>> {
    const obs = getManyBaseMgmtRecoveringProductControllerRecoveringProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple RecoveringProducts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtRecoveringProductControllerRecoveringProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtRecoveringProductControllerRecoveringProduct(params?: GetManyBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<GetManyRecoveringProductResponseDto> {
    const resp = this.getManyBaseMgmtRecoveringProductControllerRecoveringProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyRecoveringProductResponseDto>): GetManyRecoveringProductResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtRecoveringProductControllerRecoveringProduct()` */
  static readonly CreateOneBaseMgmtRecoveringProductControllerRecoveringProductPath = '/api/mgmt/recovering-product';

  /**
   * Create a single RecoveringProduct.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtRecoveringProductControllerRecoveringProduct()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response(params: CreateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProduct>> {
    const obs = createOneBaseMgmtRecoveringProductControllerRecoveringProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single RecoveringProduct.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOneBaseMgmtRecoveringProductControllerRecoveringProduct(params: CreateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<RecoveringProduct> {
    const resp = this.createOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringProduct>): RecoveringProduct => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtRecoveringProductControllerRecoveringProduct()` */
  static readonly GetOneBaseMgmtRecoveringProductControllerRecoveringProductPath = '/api/mgmt/recovering-product/{id}';

  /**
   * Retrieve a single RecoveringProduct.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtRecoveringProductControllerRecoveringProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response(params: GetOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProduct>> {
    const obs = getOneBaseMgmtRecoveringProductControllerRecoveringProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single RecoveringProduct.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtRecoveringProductControllerRecoveringProduct(params: GetOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<RecoveringProduct> {
    const resp = this.getOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringProduct>): RecoveringProduct => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtRecoveringProductControllerRecoveringProduct()` */
  static readonly DeleteOneBaseMgmtRecoveringProductControllerRecoveringProductPath = '/api/mgmt/recovering-product/{id}';

  /**
   * Delete a single RecoveringProduct.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtRecoveringProductControllerRecoveringProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response(params: DeleteOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtRecoveringProductControllerRecoveringProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single RecoveringProduct.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtRecoveringProductControllerRecoveringProduct(params: DeleteOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtRecoveringProductControllerRecoveringProduct()` */
  static readonly UpdateOneBaseMgmtRecoveringProductControllerRecoveringProductPath = '/api/mgmt/recovering-product/{id}';

  /**
   * Update a single RecoveringProduct.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtRecoveringProductControllerRecoveringProduct()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response(params: UpdateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProduct>> {
    const obs = updateOneBaseMgmtRecoveringProductControllerRecoveringProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single RecoveringProduct.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateOneBaseMgmtRecoveringProductControllerRecoveringProduct(params: UpdateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<RecoveringProduct> {
    const resp = this.updateOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringProduct>): RecoveringProduct => r.body)
    );
  }

  /** Path part for operation `recoverOneBaseMgmtRecoveringProductControllerRecoveringProduct()` */
  static readonly RecoverOneBaseMgmtRecoveringProductControllerRecoveringProductPath = '/api/mgmt/recovering-product/{id}/recover';

  /**
   * Recover one RecoveringProduct.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recoverOneBaseMgmtRecoveringProductControllerRecoveringProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  recoverOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response(params: RecoverOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = recoverOneBaseMgmtRecoveringProductControllerRecoveringProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Recover one RecoveringProduct.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recoverOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recoverOneBaseMgmtRecoveringProductControllerRecoveringProduct(params: RecoverOneBaseMgmtRecoveringProductControllerRecoveringProduct$Params, context?: HttpContext): Observable<void> {
    const resp = this.recoverOneBaseMgmtRecoveringProductControllerRecoveringProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtRecoveringProductLineControllerRecoveringProductLine()` */
  static readonly GetManyBaseMgmtRecoveringProductLineControllerRecoveringProductLinePath = '/api/mgmt/recovering-product-line';

  /**
   * Retrieve multiple RecoveringProductLines.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtRecoveringProductLineControllerRecoveringProductLine()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response(params?: GetManyBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyRecoveringProductLineResponseDto>> {
    const obs = getManyBaseMgmtRecoveringProductLineControllerRecoveringProductLine(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple RecoveringProductLines.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtRecoveringProductLineControllerRecoveringProductLine(params?: GetManyBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<GetManyRecoveringProductLineResponseDto> {
    const resp = this.getManyBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyRecoveringProductLineResponseDto>): GetManyRecoveringProductLineResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine()` */
  static readonly CreateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLinePath = '/api/mgmt/recovering-product-line';

  /**
   * Create a single RecoveringProductLine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response(params: CreateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProductLine>> {
    const obs = createOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single RecoveringProductLine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine(params: CreateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<RecoveringProductLine> {
    const resp = this.createOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringProductLine>): RecoveringProductLine => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine()` */
  static readonly GetOneBaseMgmtRecoveringProductLineControllerRecoveringProductLinePath = '/api/mgmt/recovering-product-line/{id}';

  /**
   * Retrieve a single RecoveringProductLine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response(params: GetOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProductLine>> {
    const obs = getOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single RecoveringProductLine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine(params: GetOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<RecoveringProductLine> {
    const resp = this.getOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringProductLine>): RecoveringProductLine => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine()` */
  static readonly DeleteOneBaseMgmtRecoveringProductLineControllerRecoveringProductLinePath = '/api/mgmt/recovering-product-line/{id}';

  /**
   * Delete a single RecoveringProductLine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response(params: DeleteOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single RecoveringProductLine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine(params: DeleteOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine()` */
  static readonly UpdateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLinePath = '/api/mgmt/recovering-product-line/{id}';

  /**
   * Update a single RecoveringProductLine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response(params: UpdateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProductLine>> {
    const obs = updateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single RecoveringProductLine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine(params: UpdateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<RecoveringProductLine> {
    const resp = this.updateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringProductLine>): RecoveringProductLine => r.body)
    );
  }

  /** Path part for operation `mgmtRecoveringProductLineControllerSortUp()` */
  static readonly MgmtRecoveringProductLineControllerSortUpPath = '/api/mgmt/recovering-product-line/{id}/sort-up';

  /**
   * Sort Up
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtRecoveringProductLineControllerSortUp()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtRecoveringProductLineControllerSortUp$Response(params: MgmtRecoveringProductLineControllerSortUp$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProductLine>> {
    const obs = mgmtRecoveringProductLineControllerSortUp(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sort Up
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtRecoveringProductLineControllerSortUp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtRecoveringProductLineControllerSortUp(params: MgmtRecoveringProductLineControllerSortUp$Params, context?: HttpContext): Observable<RecoveringProductLine> {
    const resp = this.mgmtRecoveringProductLineControllerSortUp$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringProductLine>): RecoveringProductLine => r.body)
    );
  }

  /** Path part for operation `mgmtRecoveringProductLineControllerSortDown()` */
  static readonly MgmtRecoveringProductLineControllerSortDownPath = '/api/mgmt/recovering-product-line/{id}/sort-down';

  /**
   * Sort Down
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtRecoveringProductLineControllerSortDown()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtRecoveringProductLineControllerSortDown$Response(params: MgmtRecoveringProductLineControllerSortDown$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProductLine>> {
    const obs = mgmtRecoveringProductLineControllerSortDown(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sort Down
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtRecoveringProductLineControllerSortDown$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtRecoveringProductLineControllerSortDown(params: MgmtRecoveringProductLineControllerSortDown$Params, context?: HttpContext): Observable<RecoveringProductLine> {
    const resp = this.mgmtRecoveringProductLineControllerSortDown$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringProductLine>): RecoveringProductLine => r.body)
    );
  }

  /** Path part for operation `recoverOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine()` */
  static readonly RecoverOneBaseMgmtRecoveringProductLineControllerRecoveringProductLinePath = '/api/mgmt/recovering-product-line/{id}/recover';

  /**
   * Recover one RecoveringProductLine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recoverOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine()` instead.
   *
   * This method doesn't expect any request body.
   */
  recoverOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response(params: RecoverOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = recoverOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Recover one RecoveringProductLine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recoverOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recoverOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine(params: RecoverOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<void> {
    const resp = this.recoverOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtRecoveringStockControllerRecoveringStock()` */
  static readonly GetManyBaseMgmtRecoveringStockControllerRecoveringStockPath = '/api/mgmt/recovering-stock';

  /**
   * Retrieve multiple RecoveringStocks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtRecoveringStockControllerRecoveringStock()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtRecoveringStockControllerRecoveringStock$Response(params?: GetManyBaseMgmtRecoveringStockControllerRecoveringStock$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyRecoveringStockResponseDto>> {
    const obs = getManyBaseMgmtRecoveringStockControllerRecoveringStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple RecoveringStocks.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtRecoveringStockControllerRecoveringStock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtRecoveringStockControllerRecoveringStock(params?: GetManyBaseMgmtRecoveringStockControllerRecoveringStock$Params, context?: HttpContext): Observable<GetManyRecoveringStockResponseDto> {
    const resp = this.getManyBaseMgmtRecoveringStockControllerRecoveringStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyRecoveringStockResponseDto>): GetManyRecoveringStockResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtRecoveringStockControllerRecoveringStock()` */
  static readonly CreateOneBaseMgmtRecoveringStockControllerRecoveringStockPath = '/api/mgmt/recovering-stock';

  /**
   * Ajouter un stock d'une pointure d'un modèle de recouvrement donné.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtRecoveringStockControllerRecoveringStock()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtRecoveringStockControllerRecoveringStock$Response(params: CreateOneBaseMgmtRecoveringStockControllerRecoveringStock$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringStock>> {
    const obs = createOneBaseMgmtRecoveringStockControllerRecoveringStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ajouter un stock d'une pointure d'un modèle de recouvrement donné.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtRecoveringStockControllerRecoveringStock$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtRecoveringStockControllerRecoveringStock(params: CreateOneBaseMgmtRecoveringStockControllerRecoveringStock$Params, context?: HttpContext): Observable<RecoveringStock> {
    const resp = this.createOneBaseMgmtRecoveringStockControllerRecoveringStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringStock>): RecoveringStock => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtRecoveringStockControllerRecoveringStock()` */
  static readonly GetOneBaseMgmtRecoveringStockControllerRecoveringStockPath = '/api/mgmt/recovering-stock/{id}';

  /**
   * Retrieve a single RecoveringStock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtRecoveringStockControllerRecoveringStock()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtRecoveringStockControllerRecoveringStock$Response(params: GetOneBaseMgmtRecoveringStockControllerRecoveringStock$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringStock>> {
    const obs = getOneBaseMgmtRecoveringStockControllerRecoveringStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single RecoveringStock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtRecoveringStockControllerRecoveringStock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtRecoveringStockControllerRecoveringStock(params: GetOneBaseMgmtRecoveringStockControllerRecoveringStock$Params, context?: HttpContext): Observable<RecoveringStock> {
    const resp = this.getOneBaseMgmtRecoveringStockControllerRecoveringStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringStock>): RecoveringStock => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtRecoveringStockControllerRecoveringStock()` */
  static readonly DeleteOneBaseMgmtRecoveringStockControllerRecoveringStockPath = '/api/mgmt/recovering-stock/{id}';

  /**
   * Delete a single RecoveringStock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtRecoveringStockControllerRecoveringStock()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtRecoveringStockControllerRecoveringStock$Response(params: DeleteOneBaseMgmtRecoveringStockControllerRecoveringStock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtRecoveringStockControllerRecoveringStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single RecoveringStock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtRecoveringStockControllerRecoveringStock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtRecoveringStockControllerRecoveringStock(params: DeleteOneBaseMgmtRecoveringStockControllerRecoveringStock$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtRecoveringStockControllerRecoveringStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtRecoveringStockControllerRecoveringStock()` */
  static readonly UpdateOneBaseMgmtRecoveringStockControllerRecoveringStockPath = '/api/mgmt/recovering-stock/{id}';

  /**
   * Mise à jour d'un stock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtRecoveringStockControllerRecoveringStock()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtRecoveringStockControllerRecoveringStock$Response(params: UpdateOneBaseMgmtRecoveringStockControllerRecoveringStock$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringStock>> {
    const obs = updateOneBaseMgmtRecoveringStockControllerRecoveringStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Mise à jour d'un stock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtRecoveringStockControllerRecoveringStock$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtRecoveringStockControllerRecoveringStock(params: UpdateOneBaseMgmtRecoveringStockControllerRecoveringStock$Params, context?: HttpContext): Observable<RecoveringStock> {
    const resp = this.updateOneBaseMgmtRecoveringStockControllerRecoveringStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringStock>): RecoveringStock => r.body)
    );
  }

  /** Path part for operation `mgmtRecoveringStockControllerGetQuantityDetails()` */
  static readonly MgmtRecoveringStockControllerGetQuantityDetailsPath = '/api/mgmt/recovering-stock/{id}/quantity-details';

  /**
   * Détails de la quantité actuelle en stock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtRecoveringStockControllerGetQuantityDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtRecoveringStockControllerGetQuantityDetails$Response(params: MgmtRecoveringStockControllerGetQuantityDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringStockQuantityDetails>> {
    const obs = mgmtRecoveringStockControllerGetQuantityDetails(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Détails de la quantité actuelle en stock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtRecoveringStockControllerGetQuantityDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtRecoveringStockControllerGetQuantityDetails(params: MgmtRecoveringStockControllerGetQuantityDetails$Params, context?: HttpContext): Observable<RecoveringStockQuantityDetails> {
    const resp = this.mgmtRecoveringStockControllerGetQuantityDetails$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringStockQuantityDetails>): RecoveringStockQuantityDetails => r.body)
    );
  }

  /** Path part for operation `mgmtRecoveringStockControllerGetAlerts()` */
  static readonly MgmtRecoveringStockControllerGetAlertsPath = '/api/mgmt/recovering-stock/alerts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtRecoveringStockControllerGetAlerts()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtRecoveringStockControllerGetAlerts$Response(params?: MgmtRecoveringStockControllerGetAlerts$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = mgmtRecoveringStockControllerGetAlerts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtRecoveringStockControllerGetAlerts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtRecoveringStockControllerGetAlerts(params?: MgmtRecoveringStockControllerGetAlerts$Params, context?: HttpContext): Observable<void> {
    const resp = this.mgmtRecoveringStockControllerGetAlerts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic()` */
  static readonly GetManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristicPath = '/api/mgmt/recovering-characteristic';

  /**
   * Retrieve multiple RecoveringCharacteristics.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Response(params?: GetManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyRecoveringCharacteristicResponseDto>> {
    const obs = getManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple RecoveringCharacteristics.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic(params?: GetManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params, context?: HttpContext): Observable<GetManyRecoveringCharacteristicResponseDto> {
    const resp = this.getManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyRecoveringCharacteristicResponseDto>): GetManyRecoveringCharacteristicResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic()` */
  static readonly CreateOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristicPath = '/api/mgmt/recovering-characteristic';

  /**
   * Create a single RecoveringCharacteristic.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Response(params: CreateOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringCharacteristic>> {
    const obs = createOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single RecoveringCharacteristic.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic(params: CreateOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params, context?: HttpContext): Observable<RecoveringCharacteristic> {
    const resp = this.createOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringCharacteristic>): RecoveringCharacteristic => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic()` */
  static readonly GetOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristicPath = '/api/mgmt/recovering-characteristic/{id}';

  /**
   * Retrieve a single RecoveringCharacteristic.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Response(params: GetOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringCharacteristic>> {
    const obs = getOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single RecoveringCharacteristic.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic(params: GetOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params, context?: HttpContext): Observable<RecoveringCharacteristic> {
    const resp = this.getOneBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecoveringCharacteristic>): RecoveringCharacteristic => r.body)
    );
  }

}
